export default __webpack_public_path__ + "static/media/team-diversity.de2323b5.pdf";